import type { JSX } from 'react'

export const RedirectIcon = (): JSX.Element => (
  <use href='#redirect' height='100%' width='100%' />
)
